import { AlimentSearchParam } from "../searchParams/alimentSearchParam.ts";
import GenerateQuery from "./generateQuery.ts";
import IsNullOrEmpty from "./isNullOrEmpty.ts";

const GenerateAlimentsQuery = (searchParam: AlimentSearchParam) => {
    let query = GenerateQuery(searchParam);
    if (query.length == 0) query = '?';

    if (searchParam.categoryID != null && searchParam.categoryID != 0)
        query += `categoryID=${encodeURIComponent(searchParam.categoryID!)}&`;
    if (searchParam.userID != null && searchParam.userID != 0)
        query += `userID=${encodeURIComponent(searchParam.userID!)}&`;
    if (searchParam.isPublished != null)
        query += `isPublished=${encodeURIComponent(searchParam.isPublished!)}&`;
    if (searchParam.isPublished != null)
        query += `isValidated=${encodeURIComponent(searchParam.isValidated!)}&`;
    if (!IsNullOrEmpty(searchParam.barCode))
        query += `barCode=${encodeURIComponent(searchParam.barCode!)}&`;
    if (searchParam.storeID != null && searchParam.storeID != 0)
        query += `storeID=${encodeURIComponent(searchParam.storeID!)}&`;

    if (query == '?')
        return '';

    return query;
}
export default GenerateAlimentsQuery;